import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "social-overview-card card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "field-name" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "field-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.overview.OverviewField), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["logo", _ctx.overview.SocialNetworkLogo])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.overview.OverviewValue), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["change", _ctx.changeStyle])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["icon", _ctx.changeIcon])
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(_ctx.overview.OverviewValueChange) + "% ", 1)
      ], 2)
    ])
  ]))
}